export default function fetchTimeout(url: string, options: RequestInit, timeout = 7000): Promise<Response> {
    // Si el caller ya pasó un signal, lo respetamos. Si no, creamos uno propio.
    const controller = new AbortController();
    const externalSignal = options.signal;

    // Encadenamos cancelaciones externas para no perder el signal del caller.
    if (externalSignal) {
        if (externalSignal.aborted) {
            controller.abort();
        } else {
            externalSignal.addEventListener('abort', () => controller.abort(), { once: true });
        }
    }

    const mergedOptions: RequestInit = { ...options, signal: controller.signal };

    return new Promise<Response>((resolve, reject) => {
        const timer = setTimeout(() => {
            controller.abort();
            reject(new Error('timeout'));
        }, timeout);

        fetch(url, mergedOptions).then(
            (res) => {
                clearTimeout(timer);
                resolve(res);
            },
            (err) => {
                clearTimeout(timer);
                // Si fue abortado por el timeout, ya rechazamos con 'timeout' arriba.
                if (err && err.name === 'AbortError') {
                    return;
                }
                reject(err);
            }
        );
    });
}
